/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceInventoryTagged extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceInventoryTagged");
    }

    getFixupPrototypeFunction() { return ResourceInventoryTagged.fixupPrototype; }

    static newInstance(model: Partial<ResourceInventoryTagged>): ResourceInventoryTagged {
        let obj = Object.assign(new ResourceInventoryTagged(), model);
        ResourceInventoryTagged.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceInventoryTagged>): ResourceInventoryTagged {
        if (!model) return null;
        return ResourceInventoryTagged.newInstance(<ResourceInventoryTagged> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceInventoryTagged) {
        if (!obj) return;

        models.ResourceInventoryTagged.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceInventoryTagged): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceInventoryTagged.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * True for resources carrying at least one tag, false for those carrying none. Answered by testing the tags array, which is what the summary counts tagged resources from, so the filter and the tile it sits under cannot disagree.
     */
    is_tagged: boolean;

}
